import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    private secretKey = 'CEUOI+PmP6J+r22DHZaoFuWFy2BwVYbZENREUS'; // A securely managed key
  
    constructor() { }

    setItem(key: string, value: any): void {
        const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), this.secretKey).toString();
        localStorage.setItem(key, encryptedValue);
    }

    getItem(key: string): any {
        const encryptedValue = localStorage.getItem(key);
        if (encryptedValue) {
            const decryptedBytes = CryptoJS.AES.decrypt(encryptedValue, this.secretKey);
            const decryptedValue = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            return decryptedValue;
        }
        return null;
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }
}